<template>
  <list-popover
    ref="popover"
    :parent="parent"
    :direction="direction"
    :currentValue="currentValue"
    :multiSelect="multiSelect"
    align="center"
    :list="list"
    @select="selectOption">
  </list-popover>
</template>

<script>
  import ListPopover from './ListPopover.vue'
  import popoverContainerMixin from './popoverContainerMixin'
  import { cloneDeep } from 'lodash'

  export default {
    mixins: [
      popoverContainerMixin
    ],
    components: {
      ListPopover
    },
    props: {
      parent: {
        type: HTMLElement | SVGElement | SVGUseElement
      },
      direction: {
        type: String,
        default: 'top'
      },
      attribute: {
        type: Object
      },
      multiSelect: {
        type: Boolean,
        default: false
      },
      values: null
    },
    data () {
      return {
        selectedValues: []
      }
    },
    mounted () {
      this.selectedValues = this.values ? this.values : []
    },
    computed: {
      list () {
        return this.attribute.options
      },
      currentValue () {
        if (this.multiSelect) {
          return this.selectedValues
        } else {
          return this.attribute.value
        }
      }
    },
    methods: {
      selectOption (value) {
        let chosenAttribute = cloneDeep(this.attribute)
        chosenAttribute.value = value
        this.$emit('select', chosenAttribute)
        if (this.multiSelect) { // add the selected value so that it is highlighted
          this.selectedValues.push(chosenAttribute.value)
        }
      },
      dismissHandler () {
        this.$emit('dismiss')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectPopover.vue?6361f489